import React from 'react';
import { DashboardOutlined, GlobalOutlined, SendOutlined, WechatOutlined, TeamOutlined, SettingOutlined,
  UnorderedListOutlined, LinkOutlined, RobotOutlined, ApiOutlined, ThunderboltOutlined, MailOutlined, BellOutlined, WarningOutlined } from '@ant-design/icons';

export function getNavigation(user, hasPermission) {
  const admin = user?.role === 'super_admin';
  const section = (path, label, icon, children) => {
    const items = children?.filter(Boolean);
    return children && !items.length ? null : { path, label, icon, children: items };
  };
  return [
    section('/dashboard', '仪表盘', <DashboardOutlined />),
    hasPermission('sites', 'read') && section('/sites', '实时岗位', <GlobalOutlined />),
    section('/push-records', '推送记录', <SendOutlined />, [
      hasPermission('pushRecords', 'read') && { path: '/push-records', label: '推送列表', icon: <UnorderedListOutlined /> },
      hasPermission('wechatRecords', 'read') && { path: '/push-records/extraction-failures', label: '提取失败', icon: <WarningOutlined /> },
      admin && { path: '/push-records/submission-settings', label: '报名提交', icon: <ApiOutlined /> },
      admin && { path: '/push-records/failure-alerts', label: '推送反馈', icon: <BellOutlined /> }
    ]),
    section('/wechat-records', '微信消息', <WechatOutlined />, [
      hasPermission('wechatRecords', 'read') && { path: '/wechat-records', label: '消息列表', icon: <WechatOutlined /> },
      hasPermission('groupConfig', 'read') && { path: '/wechat-records/groups', label: '报名处理规则', icon: <TeamOutlined /> }
    ]),
    section('/users', '用户管理', <TeamOutlined />, [
      hasPermission('userManagement', 'read') && { path: '/users', label: '用户列表', icon: <UnorderedListOutlined /> },
      admin && { path: '/users/robot-access', label: '机器人访问授权', icon: <LinkOutlined /> }
    ]),
    admin && section('/settings', '系统设置', <SettingOutlined />, [
      { path: '/settings/robots', label: '机器人管理', icon: <RobotOutlined /> },
      { path: '/settings/job-source', label: '岗位查询', icon: <GlobalOutlined /> },
      { path: '/settings/ai', label: 'AI 模型', icon: <ThunderboltOutlined /> },
      { path: '/settings/mail', label: '邮件服务', icon: <MailOutlined /> }
    ])
  ].filter(Boolean);
}
